var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":"","px-2":""}},[_c('div',{staticClass:"py-2 label"},[_vm._t("label")],2),_c('PercentageGraph',{attrs:{"visible":"","data":_vm.graphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }